// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3f31ab06","455":"32d35ce8","977":"6689a0a4"}[chunkId] + ".chunk.js";
};